import React,{useEffect, useState} from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { getUserSubEvent } from '../../services/UserServices/UserService';
import PageTitle from '../layouts/PageTitle';
const SubEvents = () => {
 

 
 

   const { state } = useLocation();
 
 

 
 
   


 



  return (
    <div className="qx-page">
         {/* <PageTitle
 
          activeMenu={`        ${state?.user?.hostName} >  ${historyData?.event?.name?.name} > Sub Events`}
          pathBack={true}   
        /> */}
         <h3 className="mb-4  head font-fm" style={{ color: "#27272A" , fontSize: "20px"}}>

      </h3>




 
      {!state || state.length === 0 ? (
        <div className="text-center mt-5">
          <h4 style={{ color: "#A60000" }}>sub events are not available</h4>
        </div>
      ) : (state.map((s, i) => (
    <div key={i} className="col-md-4 mb-4">
      <div className="      crds  ">
        <div className="card-body cdd">
          <div>
            <p className="fw-semibold mb-1 title">Sub Event name</p>
            <p className="mb-2 name_field">{s.name}</p>
          </div>
          <div>
            <p className="fw-semibold mb-1 title">Time</p>
            <p className="mb-0 name_field">{s.dateTime}</p>
          </div>
        </div>
      </div>
    </div>
  )))  }





 
</div>

  )
}

export default SubEvents
